import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const TicketsTagSelect = ({ selectedTagIds = [], onChange }) => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    api.get("/tags").then(({ data }) => setTags(data)).catch(toastError);
  }, []);

  return (
    <div style={{ width: 130, marginTop: -4, marginLeft: 6 }}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedTagIds}
          onChange={event => onChange(event.target.value)}
          renderValue={() => i18n.t("ticketsTagSelect.placeholder")}
          MenuProps={{ getContentAnchorEl: null }}
        >
          {tags.map(tag => (
            <MenuItem dense key={tag.id} value={tag.id}>
              <Checkbox
                size="small"
                checked={selectedTagIds.indexOf(tag.id) > -1}
                style={{ color: tag.color }}
              />
              <ListItemText primary={tag.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsTagSelect;
